import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";

const PageId = 12;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    title: "A truly connected home,\nall in one place",
    description: `With the Infosys Connectivity Platform, your\nhome network doesn’t just connect devices—it\nenhances the way you live. Manage your smart\nhome, optimize connectivity, and ensure\nseamless entertainment, all from a single\ninterface.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`<ul><li>TV App Integration – Control Wi-Fi, manage\nsmart home devices, and optimize network\nperformance—all from your TV.</li>\n<li>Effortless Device Sharing – Share your Wi-Fi\npassword in a tap, perfect for guests and family.</li>\n<li>Unified Home Control – Seamlessly switch\nbetween smart home automation, streaming, and\ngaming in one place.</li></ul>\n`}
      />
    ),

    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
